import logo from "./logo.svg";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/landing";
import Auth from "./pages/auth";
import Jobs from "./pages/jobs";
import useStore from "./store/zustandstore";
import AdminLoader from "./components/admin/adminLoader";
import Redeem from "./pages/redeem";
import ConfirmPay from "./pages/confirmpay";
import Loader from "./components/loader";
import About from "./pages/about";
import Referral from "./pages/referral";
import CertVerification from "./pages/certverification";
import Admin from "./pages/admin";
import Terms from "./pages/terms";
import ProtectedAdminRoute from "./components/adminprotected";
import Userdash from "./pages/userdash";
import Protected from "./components/protected";
import AuthProvider from "./firebase/authprovider";
import CompleteTest from "./pages/completedscreening";
import WorkPopUp from "./components/workpage/workpagepopup";
import Privacy from "./pages/privacy-policy";
import Workspace from "./pages/work";
import Completetask from "./pages/complete";
import Notfound from "./pages/404";
import { useEffect } from "react";
import PreScreening from "./pages/prescreen";
import ScreeningWorkspace from "./pages/screening";
import Maintenance from "./pages/maintenance";
import UploadQuestion from "./pages/uploadscreeningtask";

function App() {

    const screenLoader = useStore((s) => s.screenLoader);
    const hideScreenLoader= useStore((s)=>s.hideScreenLoader)
    useEffect(()=>{
       hideScreenLoader()
    },[])
  return (
    <div className="App">
          <HelmetProvider>

      <BrowserRouter>
        <AuthProvider />
        {screenLoader && <Loader />}
        <Routes>
          <Route path="*" element={<Notfound />} />
          <Route path="/" element={<Landing />} />
\          <Route path="/certificate-verification" element={<CertVerification />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/complete/:taskId/:completeMethod/:payOut/:aIScore" element={<Completetask />} />
          <Route
            path="/jobs"
            element={
              <Protected>
                <Jobs/>
              </Protected>
            }
          />
          {/* <Route
            path="/dashboard"
            element={
              <Protected>
                <Maintenance />
              </Protected>
            }
          /> */}
          <Route
            path="/dashboard"
            element={
              <Protected>
                <Userdash />
              </Protected>
            }
          />
          <Route
            path="/workpopup/:taskId/:taskType"
            element={
              <Protected>
                <WorkPopUp />
              </Protected>
            }
          />

          <Route
            path="/prescreening"
            element={
                     <Protected>

                <PreScreening />
                      </Protected>

            }
          />
          <Route
            path="/redeemtokens"
            element={
                     <Protected>

                <Redeem />
                   </Protected>
            }
          />
          <Route
            path="/confirmpayment"
            element={
                     <Protected>

                <ConfirmPay />
                   </Protected>
            }
          />
          <Route
            path="/screeningcomplete"
            element={
                <CompleteTest />
            }
          />
          <Route
            path="/about"
            element={
                <About />
            }
          />
          <Route
            path="/referral-program"
            element={
                <Referral />
            }
          />
          <Route
            path="/terms-of-service"
            element={
                <Terms />
            }
          />
          <Route
            path="/privacy-policy"
            element={
                <Privacy />
            }
          />
    
          <Route
            path="/workspace/:taskId/:taskType"
            element={
              <Protected>
                <Workspace />
              </Protected>
            }
          />
          <Route
            path="/screening/:taskId"
            element={
              <Protected>
                <ScreeningWorkspace />
              </Protected>
            }
          />
          <Route
            path="/admin"
            element={
              <Protected>
                <Admin />
              </Protected>
            }
          />
                    <Route 
  path="/admin/upload-quiz" 
  element={
    <ProtectedAdminRoute>
      <UploadQuestion />
    </ProtectedAdminRoute>
  } 
/>

        </Routes>

       
      </BrowserRouter>
          </HelmetProvider>


    </div>
  );
}

export default App;
